import {
  selectOrganizationId,
  useReorderTourFramesMutation,
} from '@carboncopyco/data';
import type { TourFrame } from '@carboncopyco/types';
import { AnalyticsTrackEventName, useAnalytics } from '@carboncopyco/utils';
import { useSelector } from 'react-redux';
import { useTourDispatch } from '../../../../hooks';
import { setIsGeneratingReplayFrameChunks } from '../../../../store';
import { useTourEditorPageProps } from '../../TourEditorPageContext';

interface Props {
  tourId: string;
}

const useFrameListActions = ({ tourId }: Props) => {
  const { uuid } = useTourEditorPageProps();
  const organizationId = useSelector(selectOrganizationId);
  const { trackEvent } = useAnalytics();
  const dispatch = useTourDispatch();
  const [reorderTourFrames] = useReorderTourFramesMutation();

  const saveReorderedFrames = (updatedFrames: TourFrame[]) => {
    const updatedFramesOrder = updatedFrames.map(
      (frame: TourFrame) => frame.id
    );
    dispatch(
      setIsGeneratingReplayFrameChunks({
        uuid,
        isGenerating: true,
      })
    );
    reorderTourFrames({
      organizationId,
      id: Number.parseInt(tourId),
      frameIds: updatedFramesOrder,
    });
    trackEvent(AnalyticsTrackEventName.TOUR_REORDER_FRAMES, {
      location: 'tour_editor_sidebar_frame_name',
      tourId,
      framesOrder: updatedFramesOrder,
    });
  };

  return {
    saveReorderedFrames,
  };
};

export default useFrameListActions;
